import { ptBR } from './ptBR';
import { enUS } from './enUS';

const translations = {
  'pt-BR': ptBR,
  'en-US': enUS,
  en: enUS, // backward compatibility
};

export function getTranslations(lang) {
  return translations[lang] || translations['pt-BR'];
}

export { ptBR, enUS };
